import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applicationQuestions';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';
import { templeteDeleteQuestions } from '../api/constants';

type useDeleteTemplateQuestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteTemplateQuestion = ({
  setErrorText = () => { },
}: useDeleteTemplateQuestionProps) => {
  const client = useQueryClient();

  const {
    mutate: deleteApplicationQuestion,
    isLoading: isDeleteApplicationQuestionLoading,
  } = useMutation({
    mutationFn: (variables: { question_id: number, etemplate_id: number }) =>
      axiosInstance
        .post(templeteDeleteQuestions, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        client.invalidateQueries([templateList]);
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return { deleteApplicationQuestion, isDeleteApplicationQuestionLoading };
};
